<div class="d-flex align-items-start g-g">
  <form
    [formGroup]="mimoOptionsForm"
    (ngSubmit)="addMimoOption()"
    class="d-flex align-items-center g-g w-50"
  >
    <input
      type="text"
      formControlName="mimo"
      class="form-control flex-fill"
      placeholder="e.g. 1X1"
    />
    <button
      type="submit"
      [disabled]="mimoOptionsForm.invalid"
      class="btn btn-success text-nowrap"
    >
      <i class="fa-solid fa-circle-plus"></i>
      <i class="fa-solid fa-caret-right"></i>
    </button>
  </form>

  <ul
    class="flex-fill d-flex flex-column g-g mimo-subsection align-self-stretch"
  >
    <!-- Default -->
    @for (mimo of defaultMimoOptions; track mimo; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between mimo-option default"
      >
        <span class="mimo-config-property-value">{{ mimo }}</span>
        <span>default</span>
      </li>
    }
    <!-- Custom -->
    @for (mimo of editableMimoOptions; track mimo; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between mimo-option"
      >
        <span class="mimo-config-property-value">{{ mimo }}</span>
        <button (click)="removeMimoOption(i)" class="remove-button">
          <i class="fa-solid fa-trash"></i>
        </button>
      </li>
    }
  </ul>
</div>
